import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add interceptor to include token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response.data;
};

export const getContent = async () => {
  const response = await api.get('/content');
  return response.data;
};

export const updateSection = async (section, data) => {
  const response = await api.put(`/content/${section}`, data);
  return response.data;
};

export const addItem = async (section, item) => {
  const response = await api.post(`/content/${section}/items`, item);
  return response.data;
};

export const updateItem = async (section, id, item) => {
  const response = await api.put(`/content/${section}/items/${id}`, item);
  return response.data;
};

export const deleteItem = async (section, id) => {
  const response = await api.delete(`/content/${section}/items/${id}`);
  return response.data;
};

export const submitForm = async (formType, payload) => {
  const response = await api.post('/forms/submit', { formType, payload });
  return response.data;
};

export const downloadReport = async (payload) => {
  const response = await api.post('/reports/download', payload);
  return response.data;
};

export default api;
